var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"alignment-record",class:`a${_vm.number}`,on:{"mouseover":_vm.onOver,"mouseout":_vm.onOut}})
}
var staticRenderFns = []

export { render, staticRenderFns }